import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { value: "" }
const _hoisted_3 = ["value"]

import { computed, onBeforeMount, ref } from 'vue';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { useRoute, useRouter } from 'vue-router';
import { Flash } from '@/core/Flash';
import LoginLayout from '@/modules/login/components/LoginLayout.vue';
import AppInput from '@/core/components/form/AppInput.vue';
import AppFormGroup from '@/core/components/form/AppFormGroup.vue';
import AppSelect from '@/core/components/form/AppSelect.vue';
import AppButton from '@/core/components/form/AppButton.vue';
import { UserUpdate } from '@/modules/user/User';
import { ErrorBag, handleFormError, handleLoadError } from '@/core/common';
import { LawFirm, useLawFirm } from '@/modules/law_firm/LawFirm';
import { getAllLanguages, Language } from '@/modules/parameters/Language';


export default /*#__PURE__*/_defineComponent({
  __name: 'PublicRegister',
  setup(__props) {

const { $gettext, interpolate } = useGettext();
const resource = useLawFirm();
const lawFirm = ref<LawFirm | null>(null);
const pageTitle = computed(() => interpolate(
	$gettext('Registrera användare för %{ name }'),
	{name: lawFirm.value?.name},
));
const route = useRoute();
const router = useRouter();
const languages = ref<Language[]>([]);
const errors = ref<ErrorBag>({});
const user = ref<UserUpdate>({});

onBeforeMount(async () => {
	try {
		lawFirm.value = await resource.getByUserInvite(route.params.hash as string);
	} catch (e) {
		handleLoadError(e as Error, 'login');
	}

	languages.value = await getAllLanguages();
});

const save = async () => {
	errors.value = {};

	try {
		user.value = await resource.answerUserInvite(route.params.hash as string, user.value);

		Flash.success($gettext('Ditt konto har nu skapats, välkommen!'));

		router.push({
			name: 'login',
		});
	} catch (e) {
		return handleFormError(e as Error, errors);
	}
};

return (_ctx: any,_cache: any) => {
  const _component_translate = _resolveComponent("translate")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createBlock(LoginLayout, { "page-title": pageTitle.value }, {
    default: _withCtx(() => [
      _createElementVNode("h1", null, _toDisplayString(pageTitle.value), 1),
      _createElementVNode("form", {
        onSubmit: _withModifiers(save, ["prevent"])
      }, [
        _createVNode(AppFormGroup, {
          id: "user_name",
          errors: errors.value.name,
          label: _unref($gettext)('Namn')
        }, {
          default: _withCtx(() => [
            _createVNode(AppInput, {
              id: "user_name",
              modelValue: user.value.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((user.value.name) = $event)),
              required: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["errors", "label"]),
        _createVNode(AppFormGroup, {
          id: "user_email",
          errors: errors.value.email,
          label: _unref($gettext)('E-post')
        }, {
          default: _withCtx(() => [
            _createVNode(AppInput, {
              type: "email",
              id: "user_email",
              modelValue: user.value.email,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((user.value.email) = $event)),
              required: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["errors", "label"]),
        _createVNode(AppFormGroup, {
          id: "user_password",
          errors: errors.value.password,
          label: _unref($gettext)('Lösenord')
        }, {
          default: _withCtx(() => [
            _createVNode(AppInput, {
              type: "password",
              id: "user_password",
              modelValue: user.value.password,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((user.value.password) = $event)),
              placeholder: "********",
              required: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["errors", "label"]),
        _createVNode(AppFormGroup, {
          id: "user_language",
          errors: errors.value.language,
          label: _unref($gettext)('Språk')
        }, {
          default: _withCtx(() => [
            _createVNode(AppSelect, {
              id: "user_language",
              modelValue: user.value.language,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((user.value.language) = $event)),
              required: ""
            }, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createElementBlock("option", _hoisted_2, [
                  _createTextVNode("(Välj)")
                ])), [
                  [_directive_translate]
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(languages.value, (language) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: language.id,
                    value: language.id
                  }, _toDisplayString(language.name), 9, _hoisted_3))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["errors", "label"]),
        _createVNode(AppButton, {
          type: "submit",
          class: "t-primary button-block"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_translate, null, {
              default: _withCtx(() => [
                _createTextVNode("Spara")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ], 40, _hoisted_1)
    ]),
    _: 1
  }, 8, ["page-title"]))
}
}

})